import styled from 'styled-components';
import { GalleryImageProps, GalleryStyledProps } from './Gallery.typed';

export const Gallery = styled.div<GalleryStyledProps>`
  position: relative;
  max-height: 100%;
  height: ${({ height }) => height ?? '100%'};
  overflow: hidden;
`;

export const GalleryImage = styled.div<GalleryImageProps>`
  text-align: center;
`;

export const Item = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  ${({ theme }) => theme.components.gallery.controls.base};

  border-radius: 50%;
`;

export const Controls = styled.div`
  button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    color: #fff;
    border-radius: 50%;

    &:first-child {
      left: 0;

      svg {
        transform: rotate(90deg);
        height: 20px;
        width: 20px;
      }
    }
    &:last-child {
      right: 0;

      svg {
        transform: rotate(-90deg);
        height: 20px;
        width: 20px;
      }
    }
  }
`;
